var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ja/phone_number/index.js
 ** module id = 799
 ** module chunks = 0
 **/